export default {
    data: () => ({
        translations: {
            card_number: {
                el: "Αριθμός Κάρτας",
                en: "Card Number",
                it: "Numero di carta"
            },
            card_password: {
                el: "Κωδικός Πίσω Όψης",
                en: "Card Back Code ",
                it: "Codice Lato Posteriore"
            },
            reference_number: {
                el: "Αριθμός Αναφοράς",
                en: "Reference number",
                it: "Numero di riferimento"
            },
            used: {
                el: "Σε Χρήση",
                en: "Used",
                it: "Usato"
            },
            volume: {
                el: "Αριθμός Καρτών",
                en: "Volume",
                it: "Numero di Carte"
            },
            cardType: {
                el: "Τύπος Κάρτας",
                en: "Card Type",
                it: "Tipo di Carta"
            },
            createOrder: {
                el: "Νέα Παραγγελία",
                en: "Create Order",
                it: "Nuovo ordine"
            },
            activated_at: {
                el: "Ημ/νια Ενεργοποίησης",
                en: "Activated at",
                it: "Attivato"
            },
            actions: {
                el: "Ενέργειες",
                en: "Actions",
                it: "Azioni"
            },
            delete: {
                el: "Διαγραφή",
                en: "Delete",
                it: "Cancellare"
            },
            card_type: {
                el: "Τύπος Κάρτας",
                en: "Card Type",
                it: "Tipo di carta"
            },
            paginationText: {
                el: "από",
                en: "of",
                it: "di"
            }
        }
    })
};
